module.exports = __webpack_public_path__ + "08.svg?96879a989712f0e1f61b5ed1b166a6c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_setting/08.svg
// module id = 67
// module chunks = 0